import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './sic-annuities-hero.css.lit';

/*
 * The annuities hero component
 * @element sic-annuities-hero
 *
 * @slot eyebrow - The heading eyebrow
 * @slot heading - Heading
 * @slot dropdown heading - Heading over the dropdown
 * @slot dropdown help - Help text for the dropdown
 * @slot dropdown menu - The dropdown menu
 * @slot cta-title - Title cta menu
 * @slot cta-menu - menu of cta links for the annuities hero
 *
 * Lightdom styles in sic-annuities-hero.lightdom.css included in /shared.css
 */
@customElement('sic-annuities-hero')
export class SicAnnuitiesHero extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="annuities-hero-wrapper">
        <div class="text-wrapper">
          <div class="heading-wrapper">
            <slot name="eyebrow"></slot>
            <slot name="heading"></slot>
          </div>
          <div class="drop-down-wrapper">
            <slot name="dropdown-title"></slot>

            <slot name="dropdown-menu"></slot>
          </div>
        </div>
        <div class="cta-menu-wrapper">
          <div class="cta-title">
            <slot name="cta-title"></slot>
          </div>
          <slot name="cta-menu"></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-annuities-hero': SicAnnuitiesHero;
  }
}
